// extracted by mini-css-extract-plugin
export default {"loaderContainer":"PageLoader_loaderContainer__78+sf","loaderTitle":"PageLoader_loaderTitle__arCe7"};